var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-card-icons"},[_c('i',{staticClass:"nexd-icon-32-delete",attrs:{"aria-hidden":"true"},on:{"click":_vm.deleteAsset}})])
}
var staticRenderFns = []

export { render, staticRenderFns }